import styled from 'styled-components';
import { FlexDiv } from 'common/styles';
import { ButtonLadingContainer, BUTTON_PRIMARY } from 'components/TCButton/styles';
import { SIZE } from 'common/sizes';
import { COLOR_PALETTE } from 'common/colors';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

interface IRootProps {
    flexDirectionValue?: string;
    textAlignValue?: string;
    fontSizeValue?: string;
    colorValue?: string;
}

export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: ${(props: IRootProps) => (props.flexDirectionValue ?? 'row')};
    justify-content: center;
    align-items: center;
    padding: 30px;
    box-sizing: border-box;
`;

export const Col = styled.div`
    display: flex;
    align-items: center;
    padding: 19px;
`;

export const Text = styled.div`
    font-family: Rubik;
    font-size: ${(props: IRootProps) => (props.fontSizeValue ?? '30px')};;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: ${(props: IRootProps) => (props.textAlignValue ?? 'left')};
    color: ${(props: IRootProps) => (props.colorValue ?? '#000')};;
    white-space: pre-line;
`
